import { render, staticRenderFns } from "./ActorDirectorInput.vue?vue&type=template&id=3848b10a&scoped=true"
import script from "./ActorDirectorInput.vue?vue&type=script&lang=js"
export * from "./ActorDirectorInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848b10a",
  null
  
)

export default component.exports